import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DetailPageLayout from "../../../components/detail/DetailPageLayout";
import popupMessage from "../../../services/popupMessage";
import { instanceToken } from "../../../utils/constant";
import { dateInfoItems } from "../../../utils/detailUtils";

const PopupMessage = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const res = await popupMessage.findOne(instanceToken.token, id);
        setMessage(res?.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchMessage();
  }, [id]);

  const handleRemove = async () => {
    try {
      await popupMessage.remove(instanceToken.token, id);
      homeAlert("Popup message has been removed.", false);
      navigate("/popup-messages");
    } catch (error) {
      console.log(error);
      homeAlert("Error on server!", true);
    }
  };

  const title =
    message?.title && message.title !== "undefined" ? message.title : "";

  return (
    <DetailPageLayout
      title="Popup Message Details"
      subtitle="View and manage popup message"
      breadcrumbs={[
        { label: "Popup Messages", path: "/popup-messages" },
        { label: `Popup (ID - ${id})` },
      ]}
      listPath="/popup-messages"
      imageUrl={message?.image_url}
      loading={!message}
      editPath={message ? `/popup-messages/update/${message.id}` : undefined}
      onRemove={handleRemove}
      infoItems={
        message
          ? [
              { label: "ID", value: String(message.id), icon: "id" },
              { label: "Title", value: title || "—", icon: "title" },
              ...dateInfoItems(message),
            ]
          : []
      }
      infoTitle="Popup Information"
      quickActions={
        message?.image_url
          ? [
              {
                label: "Preview Image",
                onClick: () =>
                  window.open(message.image_url, "_blank", "noreferrer"),
              },
            ]
          : []
      }
    />
  );
};

export default PopupMessage;
